"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _reactModal = _interopRequireDefault(require("../../../components/reactModal"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var UninstallModal = function UninstallModal(_ref) {
  var headerTitle = _ref.headerTitle,
      closeUninstallModal = _ref.closeUninstallModal,
      onUninstall = _ref.onUninstall,
      showUninstallModal = _ref.showUninstallModal,
      _ref$enabledIntegrati = _ref.enabledIntegrationCount,
      enabledIntegrationCount = _ref$enabledIntegrati === void 0 ? 0 : _ref$enabledIntegrati,
      additionalText = _ref.additionalText,
      _ref$customDescriptio = _ref.customDescriptionTemplate,
      customDescriptionTemplate = _ref$customDescriptio === void 0 ? null : _ref$customDescriptio,
      _ref$isUninstallBtnDi = _ref.isUninstallBtnDisabled,
      isUninstallBtnDisabled = _ref$isUninstallBtnDi === void 0 ? false : _ref$isUninstallBtnDi,
      customUninstallBtnText = _ref.customUninstallBtnText;
  var enabledIntegrations = enabledIntegrationCount > 1 ? "".concat(enabledIntegrationCount, " integrations are currently in use.") : "".concat(enabledIntegrationCount, " integration is currently in use.");
  return (0, _preact.h)(_reactModal.default, {
    isOpen: showUninstallModal,
    onClose: function onClose() {
      return closeUninstallModal();
    }
  }, (0, _preact.h)("div", {
    className: "uninstall-confirmation-modal"
  }, (0, _preact.h)("h3", {
    className: "modal-title"
  }, "Uninstall ", headerTitle, "?"), (0, _preact.h)("div", {
    className: "modal-description"
  }, customDescriptionTemplate !== null && customDescriptionTemplate !== void 0 ? customDescriptionTemplate : (0, _preact.h)("div", null, enabledIntegrationCount !== 0 && (0, _preact.h)("p", {
    className: "modal-description-enabled-integrations-text"
  }, " ", enabledIntegrations), (0, _preact.h)("p", null, "Credentials will be deleted and all integrations will be disabled automatically. This action can\u2019t be reverted."), additionalText && (0, _preact.h)("p", null, additionalText))), (0, _preact.h)(_Button.default, {
    size: "medium",
    variant: "warning",
    title: customUninstallBtnText !== null && customUninstallBtnText !== void 0 ? customUninstallBtnText : 'Uninstall and delete credentials',
    className: "qa-uninstall-and-delete-credentials",
    disabled: isUninstallBtnDisabled,
    onClick: function onClick() {
      return onUninstall();
    }
  }), (0, _preact.h)(_Button.default, {
    size: "medium",
    title: "Cancel",
    onClick: function onClick() {
      return closeUninstallModal();
    },
    className: "qa-cancel-uninstall-and-delete-credentials"
  })));
};

var _default = UninstallModal;
exports.default = _default;